import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { api } from "./api/client";
import "./styles.css";

async function start() {
  try {
    const t = localStorage.getItem("drape.theme");
    if (t) document.documentElement.dataset.theme = t;
  } catch {
    /* storage blocked */
  }
  // Dev-only mock backend. `import.meta.env.DEV` is false in production builds, so this import is dropped.
  if (import.meta.env.DEV && import.meta.env.VITE_MOCK === "1") {
    const mock = await import("./api/mock");
    mock.handleMockLoginRedirect();
    api.setFetch(mock.mockFetch);
  }
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
}
void start();
